import { useState } from 'react';
import { Autocomplete, Box, Checkbox, Chip, Link, TextField, Typography } from '@mui/material';

function GroupsSelect({ groupsState, setGroupsState, label = "Groupes" }) {

    const [groupSearchText, setGroupSearchText] = useState("");
    const [showAll, setShowAll] = useState(false);

    const sortedGroups = [...groupsState].sort((a, b) => a.name.localeCompare(b.name, 'fr', { numeric: true, sensitivity: 'base' }));

    const handleGroupsSelectChange = (event, selected) => {
        const selectedUids = selected.map(s => s.uid);
        setGroupsState(groupsState.map(g => ({ ...g, checked: selectedUids.includes(g.uid) })));
    }

    const toggleGroup = (g) => {
        setGroupsState(groupsState.map(i => (i.uid === g.uid ? { ...i, checked: !i.checked } : i)));
    }

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle2">{label}</Typography>
                <Link component="button" type="button" variant="body2" onClick={() => setShowAll(!showAll)}>
                    {showAll ? "Masquer la liste" : "Voir tous les groupes"}
                </Link>
            </Box>
            <Autocomplete
                multiple
                disableCloseOnSelect
                size="small"
                options={sortedGroups}
                value={groupsState.filter(g => g.checked)}
                inputValue={groupSearchText}
                onInputChange={(event, newValue, reason) => {
                    if (reason === 'input') setGroupSearchText(newValue);
                }}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.uid === value.uid}
                onChange={handleGroupsSelectChange}
                renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li key={key ?? option.uid} {...optionProps}>
                            <Checkbox size="small" checked={selected} sx={{ mr: 1 }} />
                            {option.name}
                        </li>
                    );
                }}
                renderInput={(params) => <TextField {...params} placeholder="Rechercher un ou plusieurs groupes..." />}
            />
            {showAll && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1.5 }}>
                    {sortedGroups.map(g => (
                        <Chip
                            key={g.uid}
                            label={g.name}
                            size="small"
                            clickable
                            onClick={() => toggleGroup(g)}
                            color={g.checked ? "secondary" : "default"}
                            variant={g.checked ? "filled" : "outlined"}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
}

export default GroupsSelect;
